import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { AuthClient } from 'app/auth/auth.client';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'change-password',
    templateUrl: 'change-password.component.html',
    styleUrls: ['change-password.component.scss'],
  host: {class: 'bmc-change-password'}
})
export class ChangePasswordComponent {
    public code: string;
    public userName = '';
    public password = '';
    public verificationPassword = '';
    public PASSWORD_REGEX = /^.*(?=.*\d)(?=.*[A-Za-z])(?=.{6,}).*$/g;

    private listTimeOut: any[] = [];

    @ViewChild('changePasswordForm', { static: false}) changePasswordForm: NgForm;

    constructor(private _route: ActivatedRoute,
        private _router: Router,
        private _autoLoginClient: AutoLoginClient,
        private _authClient: AuthClient,
        private _translateService: TranslateService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) {

         }

    ngOnInit() {
        this._route.queryParams.subscribe((params) => {
            this.code = params['verificationToken'];
        });
    }

    ngOnDestroy(): void {
      this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
    }

    public changePassword() {
        if(!this.isPasswordInvalid()) {
            if(!this.code){
                this._router.navigate(['login']);
            }
            this._autoLoginClient.changePasword(this.password, this.code)
                .subscribe((response) => {
                    switch (response) {
                        case 'ChangePasswordSuccessful':
                            const toastDuration = 5000;
                            this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.PASSWORD_SUCCESSFULLY_CHANGED'), 'success');
                            this.listTimeOut.push(setTimeout(() => {
                                this._router.navigate(['login']);
                            }, toastDuration));
                            break;
                        case 'ValidateVerificationWrongCode':
                            this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.LINK_HAS_EXPIRED'), 'error');
                            break
                        case 'ChangePasswordUserNotFound':
                        case 'ChangePasswordUnexpectedError':
                        case 'ValidateVerificationCodeUnexpectedError':
                        default:
                            this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
                            break
                    }
            });
        }
    }

    public testRegEx() {
        const result = this.PASSWORD_REGEX.test(this.password);
        this.PASSWORD_REGEX.lastIndex= 0;
        return result;

    }

    public isPasswordInvalid(): boolean {
        return !this.testRegEx() || this.password === '' || this.verificationPassword === '' || this.verificationPassword !== this.password;
    }
}
